import { FC, useContext } from 'react'
import { useIntl } from 'react-intl'
import { SelectField } from 'src/modules/core/components'
import { TabContext } from 'src/modules/core/context/tab-context/tab-context'
import { dashboardTabs } from 'src/modules/user/constants/dashboardTabs'

export function TabSelect() {
  const { formatMessage } = useIntl()
  const { currentTabIndex, setCurrentTabIndex, setPrevTabIndex } = useContext(TabContext)

  const tabOptions = dashboardTabs.map((tab, index) => ({
    value: index,
    label: tab.titleId ? formatMessage({ id: tab.titleId }) : tab.title,
    description: tab.descriptionId ? formatMessage({ id: tab.descriptionId }) : tab.description,
  }))

  // Get current selected option
  const selectedOption = tabOptions[currentTabIndex]

  const handleChange = (option: any) => {
    setPrevTabIndex(currentTabIndex)
    setCurrentTabIndex(option.value)
  }

  return (
    <SelectField
      value={selectedOption}
      onChange={handleChange}
      closeMenuOnSelect={true}
      options={tabOptions}
      isMulti={false}
      styles={{ control: (base) => ({ ...base, padding: '2px 10px 2px 15px' }) }}
    />
  )
}
